import { Phone } from "lucide-react";
import { SITE } from "@/lib/site";

export default function StickyCallButton() {
  return (
    <a
      href={SITE.phoneHref}
      data-testid="sticky-call-button"
      className="fixed bottom-6 right-6 z-50 group flex items-center gap-3 bg-monarch-gold text-monarch-black px-5 py-4 shadow-[0_10px_40px_-10px_rgba(212,175,55,0.6)] hover:bg-monarch-champagne transition-all duration-300 hover:-translate-y-1"
    >
      <span className="relative flex w-2.5 h-2.5">
        <span className="absolute inline-flex h-full w-full rounded-full bg-monarch-black/40 animate-ping" />
        <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-monarch-black" />
      </span>
      <Phone className="w-4 h-4" />
      <span className="text-xs uppercase tracking-[0.22em] font-bold hidden sm:inline">Call to Book</span>
    </a>
  );
}
